import { useNavigate } from "react-router-dom";
import useAddFormData from "../../../../Components/Hooks/useAddFormData";
import { useState } from "react";
import * as yup from 'yup';
import { useFormik } from "formik";
import { BackButton, CancelButton, SubmitButton } from "../../../../Components/Utils/Buttons";

import { NuDate, NuInput, NuTextArea } from "../../../../Components/Utils/Input";
import axiosInstance from "../../../../Services/axiosCommon";
import UseCustomerDropDownNew from "../../../../Components/Hooks/useCustomerSearch";
import { useToast } from "../../../../Components/Others/ToastServices";
import Attachement from "../../../../Components/Utils/CustomAttrachmentupload";
import FormikSelectTwo from "../../../../Components/Utils/Select";
import useFetchMataData from "../../../../Components/Hooks/useFetchMataData";
import DropDownAddMetaData from "../../../../Components/Utils/selectAddMetaData";
import UseInspectorDD from "../../../../Components/Hooks/useInspectorSearch";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import MultiSelect from "../../../../Components/Utils/MultiSelect";
import UseDropDown from "../../../../Components/Hooks/useDropDown";


function CreateSurveyReport() {
 
  const navigate = useNavigate();
  const {  addFormData } = useAddFormData();
  const [searchClient, setSearchClient] = useState("");
  const { data: client, setDataCustomer } = UseCustomerDropDownNew(
    "/clients/drop-down",
    searchClient
  );
  // const [searchInspector, setSearch] = useState("");
  const { data: inspector, setDataInspector } = UseInspectorDD(
    "/inspectors/drop-down",
    searchClient
  );
  const [searchequipment, setSearchequipment] = useState("");
  const { data: equipment , setDataequipments } = UseCustomerDropDownNew(
    "/equipments/drop-down",
    searchequipment
  );
   const { value: status, getData: refStatus } = useFetchMataData(
      `/dropdown/dropdown-details/`,
      "Status_Survey"
    );
    
   const { data: user } = UseDropDown(`/user/drop-down`);

  const [createNew, setCreateNew] = useState({
                   
  
    attachments: [],
    clientId: "",       
    project: "",
    scope: "",
    inspector: "",
    location: "",
    inspectionDate: "",
    status: "",
    assignee:""
    
});

const [selectedFile, setSelectedFile] = useState(null);
  const [image, setImage] = useState([]);
  const toast = useToast();

  function handleImageChange(e) {
    const maxFileSize = 200000000; // 200 MB
    const files = Array.from(e.target.files);
    let fileArr = [];
    files.map((item) => {
      if (item.size < maxFileSize) {
        fileArr.push(item);
      } else {
        toast.open({
          type: "warning",
          message: `File Size to big`,
          description: `${item.name} is Removed and not Uploaded`,
          // placement: "bottomRight",
        });
      }
    });
    let tempArr = [];
    setSelectedFile(fileArr);
    files.map((item) => {
      if (item.size < maxFileSize) {
        let fileName = item?.name;
        console.log("fname", fileName);
        // let fileExtention = fileName.split(".").reverse()[0];
        // if (filetype?.includes(fileExtention)) {
        tempArr.push(fileName);
        // } else {
        //   let x = URL.createObjectURL(item);
        //   tempArr.push(x);
        // }
      }
    });
    console.log(tempArr, "temp");
    setImage(tempArr);
  }

  const removeImages = (value) => {
    console.log("value", value);
    let List = selectedFile.filter((item) => item?.name !== value);
    console.log("LIst", List);
    setSelectedFile([...List]);
    let tempArr = [];
    List.map((item) => {
      let fileName = item?.name;
      // console.log('fname',fileName);
      // let fileExtention =  fileName.split(".").reverse()[0]
      // if(filetype?.includes(fileExtention)){
      tempArr.push(fileName);
      // }else{
      //   let x = URL.createObjectURL(item)
      //   tempArr.push(x)
      // }
    });
    setImage(tempArr);
  };


const formik = useFormik({
 enableReinitialize: true,
 initialValues: createNew,
 validateOnChange: false,
 validateOnBlur: false,
 validationSchema: yup.object({
  clientId: yup.string().required("Client is required!"),
              // inspector: yup
              //   .string()
              //   .required("Inspector is required!"),
                // assignee: yup.string().required("Assignee is required!"),
                assignee: yup.array().required("Assigned To is required!"),
                

       }),
 onSubmit: async (value, { resetForm }) => {
  let formData = new FormData();
  formData.append("json_data", JSON.stringify(value));
if (selectedFile !== null) {
    selectedFile.forEach((file) => {
      formData.append("attachments", file);
    });
  } else {
    formData.append("attachments", []);
  }
        addFormData("/survey-report/new-survey-report", formData, resetForm);
 },
});

const [showPopup, setShowPopup] = useState(false);


const togglePopup = () => {
 setShowPopup(!showPopup);
};

const resetForm = () => {
//  formik.values.type = ""
 formik.values.companyName = "";
 formik.values.email = "";
 formik.values.industry = "";
   formik.values.category = "";
 // industry: "",
 formik.values.customerType = "";
 setShowPopup(false);
}

const handlePopupSubmit = async (e) => {
 e.preventDefault();
 

 const formData = new FormData();
 formData.append(
   "json_data",
   JSON.stringify({
    
     companyName: formik.values.companyName || "",
     email: formik.values.email || "",
     industry: formik.values.industry || "",
      category: formik.values.category || "",

   
   })
 );
 try {
   const response = await axiosInstance.post(
     "/survey-report/new-survey-report",
     formData
   );
       const createdAgent = response.data?.data;

       setDataCustomer((prevCustomers) => [
         {
           label: formik.values.companyName || "-",
           value: createdAgent
         },...prevCustomers
       ]);
       resetForm();
 } catch (error) {
   console.error("Error creating new customer:", error);
 }
};

const [showPopupEquipment, setShowPopupEquipment] = useState(false);


const togglePopupEqupiment = () => {
 setShowPopupEquipment(!showPopupEquipment);
};

const resetFormE = () => {

 formik.values.name = "";
 formik.values.brand = "";
 formik.values.unit = "";
   formik.values.model = "";
 
 
 setShowPopupEquipment(false);
}

const handlePopupSubmitEquipmt = async (e) => {
 e.preventDefault();
 

 const formData = new FormData();
 formData.append(
   "json_data",
   JSON.stringify({
    
     name: formik.values.name || "",
     brand: formik.values.brand || "",
     unit: formik.values.unit || "",
      model: formik.values.model || "",

   
   })
 );
 try {
   const response = await axiosInstance.post(
     "/equipments/new-equipment",
     formData
   );
       const createdEquipt = response.data?.data;

       setDataequipments((prevEquipments) => [
         {
           label: formik.values.name || "-",
           value: createdEquipt
         },...prevEquipments
       ]);
       resetFormE();
 } catch (error) {
   console.error("Error creating new customer:", error);
 }
};
 
 

  return (
    <div className=" w-full h-full py-2 px-4 ">
         <div className="flex justify-between w-full"> 
              <Breadcrumb
                    items={[
           
                      
                      {
                        name: "Survey",
                        link:"/client-management/survey-report"
                       
                      },
          
                      { name: "Create" },
                    ]}
                  />      
        <BackButton />
      </div>
      <form onSubmit={formik.handleSubmit}>
        <div className="w-full mx-auto h-[calc(100vh-145px)] bg-white rounded-xl overflow-hidden mt-4">
          <div className=" w-full h-full flex justify-start content-start flex-wrap py-2 px-4  overflow-y-auto">
            <div className="w-full">
              <p className="pb-2 pt-4 px-4 text-sm font-medium text-[#111537] underline decoration-textColor-main decoration-2 underline-offset-4">
                Survey :
              </p>
            </div>
                    <FormikSelectTwo
                             type="text"
                             label="Client "
                             placeholder="Client  "
                             Options={client}
                             formik={formik}
                             name="clientId"
                             isRequired={true}
                            width="w-full md:w-1/3 md:-mt-2"
                             
                             handleClick={togglePopup}
                             FixPosition={false}
                             PortalTarget={true}
                             
                             setSearch={setSearchClient}
                           />
            <NuInput
              type="text"
              label="Project"
              placeholder="Project"
              formik={formik}
              name="project"
              width="w-full md:w-1/3 md:-mt-2"
            />
            {/* <NuInput
              type="text"
              label="Scope"
              placeholder="scope"
              formik={formik}
              name="scope"
              width="w-full md:w-1/3 md:-mt-2"
            /> */}
              {/* <FormikSelectTwo
                             type="text"
                             label="Inspector"
                             placeholder="Inspector"
                             Options={inspector}
                             formik={formik}
                             name="inspector"
                             isRequired={true}
                            width="w-full md:w-1/3 md:-mt-2"
                             
                             handleClick={togglePopup}
                             FixPosition={false}
                             PortalTarget={false}
                             
                             setSearch={setSearchClient}
                           /> */}

<MultiSelect
              label="Assignee"
              Options={user}
              formik={formik}
              placeholder="Choose"
              name="assignee"
              isRequired={true}

              width="w-full md:w-1/3 md:-mt-2"
            />
               <NuInput
              type="text"
              label="Location"
              placeholder="Location"
              formik={formik}
              name="location"
              width="w-full md:w-1/3 md:-mt-2"
            />
              <NuDate
              label="InspectionDate"
              placeholder="InspectionDate"
              formik={formik}
              name="inspectionDate"
             
              width="w-full md:w-1/3 md:-mt-2"
            />

            <DropDownAddMetaData
                            type="text"
                            label="Status"
                            placeholder="Status"
                            Options={status}
                            formik={formik}
                            name="status"
                            width="w-full md:w-1/2 lg:w-1/3 md:-mt-3"
                            displayProperty={"Status"}
                          propertyName={"Status_Survey"}
                          getFunc={refStatus}
            
                            
                          />
        
             
            {/* <NuInput
              type="text"
              label="Location"
              placeholder="Location"
              formik={formik}
              name="location"
              width="w-full md:w-1/3 md:-mt-2"
            /> */}
            {/* <DropDownAddMetaData
                type="text"
                label="Status"
                placeholder="status"
                Options={status}
                formik={formik}
                name="status"
                width="w-full md:w-1/2 lg:w-1/3"
                isRequired={true}
                displayProperty={"Status"}
              propertyName={"Status_Survey"}
              getFunc={refStatus}

                
              /> */}
              <NuTextArea
              type="text"
              label="Scope of Work"
              placeholder="Scope of Work"
              formik={formik}
              name="scope"
              width="w-full md:w-1/2 md:-mt-2"
            />
            
         
           
          
           
                <div className="w-full">
                <p className="pb-2 pt-4 px-4 text-sm font-medium text-[#111537] underline decoration-textColor-main decoration-2 underline-offset-4">
                   Attachement :
                </p>
              </div>
              <Attachement
                handleChange={handleImageChange}
                preview={image || ""}
                width="w-full"
                label="Attach"
                multiple={true}
                removeImages={removeImages}
              />
           
           <div className="w-full  my-4 mt-8 ">
              <div className=" flex justify-end gap-4">
                 <CancelButton
                  handleClick={() => {
                    navigate(-1);
                  }}
                />
                <SubmitButton />
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

export default CreateSurveyReport